import { render, staticRenderFns } from "./Tokenization.vue?vue&type=template&id=86100766&scoped=true"
import script from "./Tokenization.vue?vue&type=script&lang=js"
export * from "./Tokenization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86100766",
  null
  
)

export default component.exports